import React from 'react'
import Interface from '../../components/admin/interface/Interface'

function InterfacePage() {
  return (
    <Interface/>
  )
}

export default InterfacePage